import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SleepChart = ({ sleepData }) => {
  // sleepData: [{ date: "2025-08-13", rem: 2, light: 5, deep: 3 }, ...]

  const data = {
    labels: sleepData.map((d) => moment(d.date).format("D MMM")),
    datasets: [
      {
        label: "REM",
        data: sleepData.map((d) => d.rem),
        backgroundColor: "#36A2EB", // blue
      },
      {
        label: "Light",
        data: sleepData.map((d) => d.light),
        backgroundColor: "#FFCE56", // yellow
      },
      {
        label: "Deep",
        data: sleepData.map((d) => d.deep),
        backgroundColor: "#FF6384", // red
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          // show stage value normally
          label: function (context) {
            return `${context.dataset.label}: ${context.raw} hrs`;
          },
          // add total hours as footer
          footer: function (tooltipItems) {
            let total = 0;
            tooltipItems.forEach((item) => {
              total += item.raw || 0;
            });
            return `Total Sleep: ${total} hrs`;
          },
        },
      },
    },
    scales: {
      x: { stacked: true },
      y: { stacked: true, beginAtZero: true, title: { display: true, text: "Hours" } },
    },
  };

  return (
    <div className="card shadow-sm mb-4 h-full">
      <div className="card-header text-center text-xl font-bold text-gray-700">
        Sleep Chart
      </div>
      <div className="card-body" style={{ height: "300px" }}>
        {sleepData && sleepData.length > 0 ? (
          <Bar data={data} options={options} />
        ) : (
          <p className="text-gray-500 font-semibold flex items-center justify-center h-full">
            No data found for selected criteria
          </p>
        )}
      </div>
    </div>
  );
};

export default SleepChart;
